import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { ThumbnailAttachmentComponent } from '../../../Component/thumbnail-attachment/thumbnail-attachment.component';

@Component({
  selector: 'app-expense-approval-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, ThumbnailAttachmentComponent],
  templateUrl: './expense-approval-detail.component.html',
  styleUrl: './expense-approval-detail.component.scss'
})
export class ExpenseApprovalDetailComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    ESS_ExpenseRequestMainId: null,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    DesignationName: null as any,
    RequestDate: null,
    ReportName: null,
    ExpenseType: null,
    ExpenseDuration: null,
    ExpenseTotal: null,
    ExpenseApproveAmount: null,
    Description: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
    BalanceAmount: null,
    AdvanceAmount: null,
  }
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;
  From = '';

  Filter = {
    ModuleMasterId: 8,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private leave: LeaveService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private expense: ExpenseService,
    protected sanitizer: DomSanitizer,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
      if (window.location.pathname.includes('outstation')) {
        this.From = 'outstation'
      } else {
        this.From = 'expense'
      }
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      //if (this.user.UserType == 'A') {
      this.ESS_GetUserRole();
      //}
    } else if (this.GetID == 2) {
      this.ESS_ExpenseRequest_SelectGet();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 8) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.GetDailyAttendanceInOutHistory();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (this.TableDatas.filter((e: any) => e.ExpenseAmount < e.ApprovedAmount).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount greater than expense amount.', type: toastTypeEnum.warning });
    } else if (this.TableDatas.filter((e: any) => e.ApprovedAmount === null || e.ApprovedAmount === '' || e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.', type: toastTypeEnum.warning });
    } else {
      if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
        modalRef.result.then((result: any) => {
          if (result) {
            this.isDisabled = true;

            if (this.TableDatas.filter((e: any) => e.ExpenseAmount != e.ApprovedAmount).length > 0) {
              const updateDate: { ESS_ExpenseRequestDetailsId: any; ApprovedAmount: any; }[] = [];
              this.TableDatas.filter((e: any) => e.ExpenseAmount != e.ApprovedAmount).forEach((element: any) => {
                updateDate.push({
                  ESS_ExpenseRequestDetailsId: element.ESS_ExpenseRequestDetailsId,
                  ApprovedAmount: element.ApprovedAmount,
                })
              });

              this.expense.ESS_ExpenseRequestUpdateAtApproval({ SelectType: 'u', ESS_ExpenseReportRequestId: this.TableDatas[0].ESS_ExpenseReportRequestId, ESS_ExpenseRequestDetails: updateDate, }).subscribe({
                next: (response) => {
                  if (response.Error_Code == '490') {
                    this.RequestAR(SelectType);
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                    this.isDisabled = false;
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            } else {
              this.RequestAR(SelectType);
            }
          }
        }).catch(() => { });
      } else {
        this.Filter.isShowError = true;
        this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
      }
    }
  }

  ESS_ExpenseRequest_SelectGet() {
    this.expense.ESS_ExpenseRequest_SelectGet({ ESS_ExpenseReportRequestId: this.Filter.WebESSApprovalRequestTrackingId, ESS_TripMasterId: null, SelectType: 'RD', EmpMasterId: this.user.UserId, TravelType: null, ESS_ExpenseRequestMainId: null, ESS_ExpenseRequestDetailsId: null, FromDate: null, ToDate: null, ApprovalStatus: 'All' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.DetailData.WebESSApprovalRequestTrackingId = 0;
          this.DetailData.TransactionId = response.Table[0].ESS_ExpenseReportRequestId;
          this.DetailData.ESS_ExpenseRequestMainId = response.Table[0].ESS_ExpenseRequestMainId;
          this.DetailData.EmpMasterId = response.Table[0].EmpMasterId;
          this.DetailData.EmpCode = response.Table[0].EmpCode;
          this.DetailData.Photo = response.Table[0].Photo;
          this.DetailData.EmployeeName = response.Table[0].EmployeeName;
          this.DetailData.RequestDate = response.Table[0].RequestDate;
          this.DetailData.ReportName = response.Table[0].ReportName;
          this.DetailData.ExpenseType = response.Table[0].ExpenseType;
          this.DetailData.ExpenseDuration = response.Table[0].ExpenseDuration;
          this.DetailData.ExpenseTotal = response.Table[0].ExpenseTotal;
          this.DetailData.Description = response.Table[0].Description;
          this.DetailData.DesignationName = response.Table[0].DesignationName;
          this.DetailData.EmpType = this.user.EmpType;
          this.DetailData.ApprovalStatus = response.Table[0].ApprovalStatus;

          this.DetailData.AdvanceAmount = response.Table[0].AdvanceAmount;
          this.DetailData.BalanceAmount = response.Table[0].BalanceAmount;
        }
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.GetDailyAttendanceInOutHistory();
      },
      error: (error) => { },
    });
  }

  RequestAR(SelectType: string) {
    this.isDisabled = true;
    //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
    this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
      next: (response) => {
        if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['/todo/expenseapproval/']);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + Text;
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/expenseapproval/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/expense/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/' + this.From + '/history/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  GetDailyAttendanceInOutHistory() {
    this.TableDatas = Object.values([]);
    this.isDisabled = true;
    this.expense.ESS_ExpenseRequest_SelectGet({
      ESS_ExpenseReportRequestId: this.DetailData.TransactionId,
      TripMasterId: null,
      SelectType: 'RR',
      EmpMasterId: this.DetailData.EmpMasterId,
      TravelType: this.DetailData.ExpenseType,
      ESS_ExpenseRequestMainId: this.DetailData.ESS_ExpenseRequestMainId,
      ESS_ExpenseRequestDetailsId: null,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
          this.TableDatas.forEach((element: any) => {
            if (element.Attachment != null && element.Attachment != '') {
              element.Attachment = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + element.Attachment
            }
          });
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  calTotal() {
    return this.TableDatas.map((e: any) => e.ApprovedAmount != '' && e.ApprovedAmount != null ? parseFloat(e.ApprovedAmount) : 0).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  calRequestAmountTotal() {
    return this.TableDatas.map((e: any) => e.ExpenseAmount != '' && e.ExpenseAmount != null ? parseFloat(e.ExpenseAmount) : 0).reduce((acc: any, cur: any) => acc + cur, 0);
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
